<template>
  <div class="ClassScheduleCard">
      <!-- <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
        <el-menu-item index="7">课程</el-menu-item>
        <el-menu-item index="8">题库</el-menu-item>
      </el-menu> -->

      <div class="null" v-if="classScheduleCardList && classScheduleCardList.length == 0">
        <img src="../../../../common/images/search/search-null.png" alt="">
        <p v-if="classScheduleCardApi.kmctype == '7'">当前没有学习的课程，快去加入课程吧！</p>
        <p v-else-if="classScheduleCardApi.kmctype == '8'">当前还没有考试的题库，快去加入题库吧！</p>
        <!-- <el-button type="prinmary" @click="gotoAddCourses">添加课程</el-button> -->
      </div>

      <div class="main" v-else>
        <div class="class-schedule-card-head">
          <div class="content">
            <div class="icon-left" v-if="classScheduleCardApi.page > 1"> <img src="../../../../common/images/index/icon-left.png" alt="left" @click.stop="pageTurning(classScheduleCardApi.page - 1)"> </div>
            <div class="head-list">

                <div :class="{'head-card':true, 'active': activeCourseid == item.courseid}" v-for="item in classScheduleCardList" :key="item.courseid" @click="clickCard(item)">

                  <div class="pay-tag" v-if="item.feetype == 2">付费课</div>

                  <template v-if="classScheduleCardApi.kmctype == '7'">
                    <el-button class="zd" @click.stop="zd(item.courseid, item.istop)" v-if="item.istop == 1">取消置顶</el-button>
                    <el-button class="zd" @click.stop="zd(item.courseid, item.istop)" v-else>置顶</el-button>
                  </template>
                 
                  <p class="text-overflow">{{item.subject}}</p>

                  <div class="progress">
                    <template v-if="item.coursetype == 2 && classScheduleCardApi.kmctype == '7'">
                      <el-progress :percentage="percentage(item.finishcount, item.totalcount)" :show-text='false'></el-progress>
                      <div v-if="item.finishcount !== 0" >
                        <p class="progress-txt">学习进度 {{item.finishcount}}/ {{item.totalcount}}</p>
                      </div>
                    </template>
                    <template v-if="classScheduleCardApi.kmctype == '8'">
                      <el-progress :percentage="percentage(1, 1)" :show-text='false' v-if="item.status == 10"></el-progress>
                      <el-progress :percentage="percentage(item.finishcount, item.totalcount)" :show-text='false' v-else></el-progress>
                      <div v-if="item.finishcount !== 0 && item.status !== 10">
                        <p class="progress-txt">考试进度 {{item.finishcount}}/ {{item.totalcount}}</p>
                      </div>
                    </template>
                  </div>
                  <div class="progress-txt_box">
                    <div class="left">
                      <p class="progress-txt" v-if="item.finishcount == 0 && classScheduleCardApi.kmctype == '7'">未学习</p>
                      <p class="progress-txt" v-if="item.status == 0 && classScheduleCardApi.kmctype == '8'">未考试</p>
                      <p class="progress-txt" v-if="item.status == 10 && classScheduleCardApi.kmctype == '8'">已完成</p>
                      <p class="progress-txt" v-if="item.status == 1 && classScheduleCardApi.kmctype == '8'">考试中</p>
                    </div>
                    <div class="right">
                      <span>{{item.expiredatename}}</span>
                    </div>
                  </div>
                </div>
            </div>
            <div class="icon-right" v-if="classScheduleCardApi.page * 4 < rowCount ">
              <img src="../../../../common/images/index/icon-right.png" alt="left" @click="pageTurning(classScheduleCardApi.page + 1)"> 
            </div>
          </div>
        </div>
        <div class="class-schedule-card-main">
          <div class="content">
            <div class="catolog-head">
              <div class="float-left">
                <h2><template v-if="classScheduleCardApi.kmctype == '7'">学习任务</template><template v-else>考试任务</template>（共{{taskcount}}节）</h2>
              </div>
              <div class="float-right">
                <div class="position">
                  <template v-if="classScheduleCardApi.kmctype == '7'">
                    <span @click="gotoRouterDetaills(activeCourseid)">课程详情</span>
                    <span class="padding">|</span>
                  </template>
                  <template v-if="classScheduleCardApi.kmctype == '8'">
                    <span @click="gotoRouterTkDetaills(activeCourseid)">题库详情</span>
                  </template>


                  <template v-if="activeCourseList.iscomment == 0 && classScheduleCardApi.kmctype == '7'">
                    <span @click="startpopu(activeCourseid)">评价课程</span>
                    <span class="padding">|</span>
                  </template>
                  
                  <span @click="participateInJointable(activeCourseid)" v-if="classScheduleCardApi.kmctype == '7'">移出课表</span>
                </div>
              </div>
            </div>

            <!-- 课程7 -->
            <template v-if="classScheduleCardApi.kmctype == '7'">
              <!-- coursetype 2 系列课 1 单课程 -->
              <div class="catolog-list cata_box" v-if="activeCourseList.coursetype == 2">
                <div class="cata_item_box" v-for="(item, index) in catalogList" :key="index">
                    <p class="cata_title_text"><span>{{item.sectionindexname}}&emsp;{{item.sectionname}}</span><span v-if="catalogList.sectionunlocktype === 2">{{item.datetime}}</span></p>
                    <div v-if="item.taskinfolist.length === 0" class="no_task_box">暂无章节任务</div>

                    <div @click="taskClick(item, subItem)" class="section_box" v-for="(subItem, subIndex) in item.taskinfolist" :key="subIndex">
                            <div>
                              <p>{{subItem.taskindexname}}</p>
                              <p>{{subItem.taskname}}</p>
                            </div>
                    <div>
                            <div class="no_hover_box">
                                  <img v-if="subItem.kmctype === '2'" :src="require('@/common/images/other/img_icon.png')" alt="">
                                  <img v-if="subItem.kmctype === '6'" :src="require('@/common/images/other/audio_icon.png')" alt="">
                                  <img v-if="subItem.kmctype === '4'" :src="require('@/common/images/other/video_icon.png')" alt="">
                                  <p>{{secondsFormat(subItem.timelength)}}</p>
                            </div>
                            <div class="hover_box">
                              <div v-if="(subItem.isunlock === 1)"><img :src="require('@/common/images/other/see_icon.png')" alt="">开始学习</div>
                              <div v-else-if="(subItem.isunlock === 0 && subItem.istry === '0')"><img :src="require('@/common/images/other/lock_icon.png')" alt="">待解锁学习</div>
                              <!-- <div v-if="courseDetailsData.feetype === 2 && courseDetailsData.isjoin === 0 && subItem.istry === '0'">需购买后观看</div> -->
                              <div v-else-if="(subItem.istry === '1')"><img :src="require('@/common/images/other/see_icon.png')" alt="">课时预览</div>
                            </div>
                        </div>
                    </div>
                </div>
              </div>
              <div class="catolog-list cata_box" v-else>
                <div class="cata_item_box" v-if="ontCourse.kmctype">
                    <!-- <p class="cata_title_text"><span>{{item.sectionindexname}}&emsp;{{item.sectionname}}</span><span v-if="catalogList.sectionunlocktype === 2">{{item.datetime}}</span></p> -->
                    <!-- <div v-if="item.taskinfolist.length === 0" class="no_task_box">暂无章节任务</div> -->
                    <div @click="gotoRouterStudy()" class="section_box" >
                            <div>
                              <!-- <p>{{ontCourse.coursetaskname}}</p> -->
                              <p class="overflow" style="line-height: 42px; width: 660px;">{{ontCourse.coursetaskname}}</p>
                            </div>
                            <div>
                            <div class="no_hover_box">
                                  <img v-if="ontCourse.kmctype === '2'" :src="require('@/common/images/other/img_icon.png')" alt="">
                                  <img v-if="ontCourse.kmctype === '6'" :src="require('@/common/images/other/audio_icon.png')" alt="">
                                  <img v-if="ontCourse.kmctype === '4'" :src="require('@/common/images/other/video_icon.png')" alt="">
                                  <p>{{secondsFormat(ontCourse.timelength)}}</p>
                            </div>
                            <div class="hover_box">
                              <div><img :src="require('@/common/images/other/see_icon.png')" alt="">开始学习</div>
                              <!-- <div v-else-if="(subItem.isunlock === 0 && subItem.istry === '0')"><img :src="require('@/common/images/other/lock_icon.png')" alt="">待解锁学习</div> -->
                              <!-- <div v-if="courseDetailsData.feetype === 2 && courseDetailsData.isjoin === 0 && subItem.istry === '0'">需购买后观看</div> -->
                              <!-- <div v-else-if="(subItem.istry === '1')"><img :src="require('@/common/images/other/see_icon.png')" alt="">课时预览</div> -->
                            </div>
                        </div>
                    </div>
                </div>
              </div>
            </template>
            <!-- 题库8 -->
            <template v-else-if="classScheduleCardApi.kmctype == '8'">

              <div class="catolog-list cata_box" v-if="activeCourseList.qbtype == 2">
                   <div class="cata_item_box" v-for="(item, index) in catalogList" :key="index">
                    <!-- <p class="cata_title_text"><span>{{item.sectionindexname}}&emsp;{{item.sectionname}}</span><span v-if="catalogList.sectionunlocktype === 2">{{item.datetime}}</span></p> -->
                    <p class="cata_title_text"><span>{{item.sectionname}}</span><span v-if="catalogList.sectionunlocktype === 2">{{item.datetime}}</span></p>
                    <div v-if="item.taskinfolist.length === 0" class="no_task_box">暂无考试任务</div>

                    <div @click="taskKsClick(getUserDoExamRecordListApi.bankid, subItem.innerid)"  class="section_box_ques" v-for="(subItem, subIndex) in item.taskinfolist" :key="subIndex">
                            <div>
                              <!-- <p>{{subItem.taskindexname}}</p> -->
                              <p></p>
                              <p>{{subItem.taskname}}</p>
                            </div>
                    <div>
                            <!-- <div class="no_hover_box"> -->
                              <!-- <img :src="require('@/common/images/other/img_icon.png')" alt=""> -->
                                  <!-- <img v-if="subItem.kmctype === '2'" :src="require('@/common/images/other/img_icon.png')" alt=""> -->
                                  <!-- <img v-if="subItem.kmctype === '6'" :src="require('@/common/images/other/audio_icon.png')" alt=""> -->
                                  <!-- <img v-if="subItem.kmctype === '4'" :src="require('@/common/images/other/video_icon.png')" alt=""> -->
                                  <!-- <p>{{secondsFormat(subItem.timelength)}}</p> -->
                            <!-- </div> -->
                            <div class="hover_box">
                               <!-- v-if="(subItem.isunlock === 1)" -->
                              <div><img :src="require('@/common/images/other/see_icon.png')" alt="">开始考试</div>
                              <!-- <div v-else-if="(subItem.isunlock === 0 && subItem.istry === '0')"><img :src="require('@/common/images/other/lock_icon.png')" alt="">待解锁学习</div> -->
                              <!-- <div v-if="courseDetailsData.feetype === 2 && courseDetailsData.isjoin === 0 && subItem.istry === '0'">需购买后观看</div> -->
                              <!-- <div v-else-if="(subItem.istry === '1')"><img :src="require('@/common/images/other/see_icon.png')" alt="">课时预览</div> -->
                            </div>
                        </div>
                    </div>
                </div>
              </div>
              <div class="catolog-list cata_box" v-else>
                 <div class="cata_item_box" v-for="(item, index) in catalogList" :key="index">
                    <div v-if="item.taskinfolist.length === 0" class="no_task_box">暂无考试任务</div>
                      <div @click="taskKsClick(getUserDoExamRecordListApi.bankid, subItem.innerid)" class="section_box" v-for="(subItem, subIndex) in item.taskinfolist" :key="subIndex">
                        <div>
                          <p style="width: 0">{{subItem.taskindexname}}</p>
                          <p>{{subItem.taskname}}</p>
                        </div>
                      <div>
                            
                      <div class="hover_box">
                          <div><img :src="require('@/common/images/other/see_icon.png')" alt="">开始考试</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            

            </template>

          </div>
        </div>
        <div class="class-schedule-card-main" v-if="classScheduleCardApi.kmctype == '8'">
             <div class="jilu">
                 <p>做题记录</p>
                 <el-table :data="getUserDoExamRecordListData">
                   <el-table-column prop="exampapername" label="试卷名称" align="left"></el-table-column>
                   <el-table-column prop="factexamtime" label="答题时间（分钟）" align="center" width="170"></el-table-column>
                   <el-table-column label="答题进度" align="center" width="100">
                     <template slot-scope="scope">
                      {{scope.row.answerquescount }}  / {{scope.row.quescount }}
                     </template>
                   </el-table-column>
                   <el-table-column prop="date" label="操作" align="right" width="280">
                     <template slot-scope="scope">
                       <div class="position-table">
                         <!-- {{scope.row.status}} -->
                        <el-button type="text" v-if="scope.row.status == 1" @click="goExam(scope.row)">继续考试</el-button>
                        <el-button type="text" v-if="scope.row.status == 10 || scope.row.status == 9" @click="seeAchievement(scope.row)">查看成绩</el-button>
                        <template v-if="scope.row.status == 10 || scope.row.status == 9 && scope.row.ismakeuptest == 1">
                          <span style="color: #E5E5E5;margin: 0 10px">|</span>
                          <el-button type="text" @click="goExam(scope.row)">重新考试</el-button>
                        </template>
                       </div>
                     </template>
                   </el-table-column>
                 </el-table>
               </div>
               <!-- 做题记录 end -->
        </div>
      </div>
      <Evaluate ref="evaluate" @evaluateSuccess='evaluateSuccess'></Evaluate>
  </div>
</template>

<script>
import Evaluate from './../components/Evaluate'
import {getUserJoinCourseList, operateJoinCourse, updateCourseListIstop, getAllQuestionbankByUser, getUserDoExamRecordList} from 'api/personalCenterApi'
import {getQuestionbankTask} from 'api/questionbank'
import {getCourseTask} from 'api/api'
import {mapActions} from 'vuex'
export default {
  name: 'ClassScheduleCard',
  data () {
    return {
      classScheduleCardList: [],  // 列表
      classScheduleCardApi: {page: 1, pageSize: 4, kmctype: '7'}, // 列表api
      getUserDoExamRecordListApi: {page: 1, pageSize: 20, bankid: ''}, // 做题记录api
      getUserDoExamRecordListData: [],  // 做题记录参数
      catalogList: [], // 目录列表
      activeCourseid: '', // 当前选中的课程
      activeCourseList: {}, // 当前选中到课程列表
      rowCount: 0,  // 总条数
      taskcount:0, // 任务数
      ontCourse: [], // 单课程
      activeIndex: '7' // 菜单切换
    }
  },
  mounted () {
    // this.getUserJoinCourseLists(1)
    this._just(this.activeIndex, 1)
  },
  methods: {
    handleSelect(val) { // 菜单切换
      this.classScheduleCardApi.kmctype = val

      this._just(val, 1) // 判断类型

    },
    getAllQuestionbankByUserLists(page) { // 获取题库列表

        this.classScheduleCardApi.page = page
        this.setLoading(true)
        
        getAllQuestionbankByUser({
          data: this.classScheduleCardApi,
          success: data => {
            this.setLoading(false)
            this.classScheduleCardList = data.data.content
            this.rowCount = data.data.pageinfo.rowCount

            // 默认第一条数据选中状态
            this.clickCard(this.classScheduleCardList[0])

          },
          error: data => {
            this.setLoading(false)
            this.$message.error(data.msg)
          }
        })
    },
    getUserDoExamRecordList(bankid) { // 获取用户考试记录列表
    this.getUserDoExamRecordListApi.bankid = bankid
      this.setLoading(true)
      getUserDoExamRecordList({
        data: this.getUserDoExamRecordListApi,
        success: data => {
          this.setLoading(false)
          this.getUserDoExamRecordListData = data.data.content
        },
        error: data => {
          this.setLoading(false)
          this.$message.error(data.msg)
        }
      })
    },
    getUserJoinCourseLists(page) {  // 课程表列表
      this.classScheduleCardApi.page = page
      this.setLoading(true)
      
      getUserJoinCourseList({
        data: this.classScheduleCardApi,
        success: data => {
          this.setLoading(false)
          this.classScheduleCardList = data.data.content
          this.rowCount = data.data.pageinfo.rowCount

          // 默认第一条数据选中状态
          this.clickCard(this.classScheduleCardList[0])

        },
        error: data => {
          this.setLoading(false)
          this.$message.error(data.msg)
        }
      })
    },
    clickCard(item) { // 列表点击
      this.activeCourseid = item.courseid
      this.activeCourseList = item

      // 获取课程目录（系列课，通用）
      this.setLoading(true)
      var params = {}
      if(this.classScheduleCardApi.kmctype == '7') {
        
        params = {
            courseid: item.courseid
        }
        
        getCourseTask({
          data: Object.assign({}, params),
          success: data => {
            this.setLoading(false)
            // 系列课目录
            this.catalogList = data.data.content
  
            // 单课程目录
            this.ontCourse = {coursetaskname: data.data.coursetaskname, singleid: data.data.singleid, kmctype: data.data.kmctype.toString(), timelength: data.data.timelength}
            // 条数
            this.taskcount = data.data.taskcount
  
          },
          error: data => {
            this.setLoading(false)
            this.$message.error(data.msg)
          }
        })
      } else {
       
        params = {
          bankid: item.courseid
        }
        getQuestionbankTask({
          data: Object.assign({}, params),
          success: data => {
            this.setLoading(false)
            // 系列课目录
            this.catalogList = data.data.content
            this.taskcount = data.data.taskcount
            // 单课程目录
            // this.ontCourse = {coursetaskname: data.data.coursetaskname, singleid: data.data.singleid, kmctype: data.data.kmctype.toString(), timelength: data.data.timelength}
            // 条数
            // this.taskcount = data.data.taskcount

          },
          error: data => {
            this.setLoading(false)
            this.$message.error(data.msg)
          }
        })

         // 获取考试记录
        this.getUserDoExamRecordList(item.courseid)
      }
    },
    startpopu(courseid) { // 评价课程
      this.$refs.evaluate.startPopu(courseid)
      // this.getUserJoinCourseLists(1)
    },
    evaluateSuccess() { // 课程评价成功
      // this.getUserJoinCourseLists(1)
      this.activeCourseList.iscomment = 1
    },
    participateInJointable(courseid) {  //移出课表
      this.$confirm('是否需要将课程移出课表?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        operateJoinCourse({
          data: {courseid: courseid, optype: 2},
          success: data => {

            this.setLoading(false)
            if (data.code == '000') {
              this.$message.success('操作成功')

              // 刷新列表
              this.getUserJoinCourseLists(1)

              // 刷新基本信息统计
              this.$parent.info()

            } else {
              this.$message.error(data.msg)
            }
              
          },
          error: data => {
            this.setLoading(false)
            this.$message.error(data.msg)
          }
        })
      }).catch(() => {})

    },
    pageTurning(page) { // 翻页
      this._just(this.classScheduleCardApi.kmctype, page)
      // this.getUserJoinCourseLists(page) //调用列表
    },
    percentage(finishcount, totalcount) {  // 百分比计算
      let sub
      finishcount = parseInt(finishcount),
      totalcount = parseInt(totalcount)
      
      if (finishcount == 0 && totalcount == 0) {
        sub = 0
      } else {
          sub = finishcount / totalcount
      }
      return  sub * 100
    },
    gotoAddCourses() {  //添加课程
      this.$router.push({
        name: 'AllCourses'
      })
    },
    // 章节任务时间转行
    secondsFormat(s) { 
        var day = Math.floor( s/ (24*3600) ) // Math.floor()向下取整
        var hour = Math.floor( (s - day*24*3600) / 3600)
        var minute = Math.floor( (s - day*24*3600 - hour*3600) /60 )
        var second = s - day*24*3600 - hour*3600 - minute*60
        // return day + "天"  + hour + "时" + minute + "分" + second + "秒";
        if(s === 0) {
            return ''
        }
        
        if(second<10){
            second='0' + second
        }
        if(minute<10){
            minute='0' + minute
        }
        if(hour<=0){
            return minute + ':' + second
        }
        return hour + ':' + minute + ':' + second
    },
    // 章节任务点击跳转到课程学习页面
    taskClick(val1, val2) {
      const { href } = this.$router.resolve({
        name: 'Study', query: {'courseid': this.activeCourseid, 'taskid': val2.innerid, 'sectionindexname': val1.sectionindexname, 'taskindexname': val2.taskindexname}
      })
      window.open(href, '_blank');
    },
    // 前往开始考试页面
    taskKsClick(val1, val2) {
      console.log(val1, val2)
      const {href} = this.$router.resolve({
        name: 'ExaminationPaperInformation',
        query: {bankid:val1,taskid: val2}
      })
      window.open(href, '_blank')
    },
    gotoRouterDetaills(cid) {  // 前往详情页面
      const { href} = this.$router.resolve({
                name: "CourseDetails",
                query: {
                    cid: cid
                }
      })
      window.open(href, '_blank');
    },
    gotoRouterStudy() { // 前往学习页面
       const { href } = this.$router.resolve({
        name: 'Study', query: {'courseid': this.activeCourseid}
      })
      window.open(href, '_blank');
    },
    zd(courseid, istop) {  // 置顶

      let istops = istop == 0 ? 1 : 0

      updateCourseListIstop({
        data: {courseid: courseid, istop: istops},
        success: data => {
          this.setLoading(false)
          if (data.code == '000') {
            this.$message.success('操作成功')
            this.getUserJoinCourseLists(1)
          } else {
            this.$message.error(data.msg)
          }
        },
        error: data => {
          this.$message.error(data.msg)
          this.setLoading(false)
        } 
      })
    },
    _just(kmctype, page) {
      if (kmctype == '7') {
        this.getUserJoinCourseLists(page)
      } else if (kmctype == '8') {
        this.getAllQuestionbankByUserLists(page)
      }
    },
    //继续考试/重新考试
    goExam(row){
      const {href} = this.$router.resolve({
        name: 'ExaminationPaperInformation',
        query: {bankid:row.bankid,taskid: row.taskinnerid}
      })
      window.open(href, '_blank')
      // console.log(row)
      // this.$router.push({name: 'ExaminationPaperInformation',query: {bankid:row.bankid,taskid: row.taskinnerid}})
    },
    //查看成绩
    seeAchievement(row){
      const {href} = this.$router.resolve({
        name: "ViewingResults",
        query: {examid:row.innerid}
      })
      window.open(href, '_blank')
    },
    // 题库详情
    gotoRouterTkDetaills() {
        const {href} = this.$router.resolve({
          name: 'QuestionDetails',
          query: {qid:this.getUserDoExamRecordListApi.bankid}
        })
        window.open(href, '_blank')
    },
    ...mapActions(['setLoading'])
  },
  filters: {},
  watch: {},
  computed: {},
  components: {
    Evaluate
  }
}
</script>

<style lang="scss" type="text/scss" scope>

.ClassScheduleCard {
  .el-menu-demo {
      padding: 0 20px;
      background: none;
      li:hover {
        &:focus,
        &:active,
        & {
          background: none !important;
        }
      }
    
    }
    .jilu {
      p {
        margin-bottom: 20px;
        font-size: 14px;
        font-weight: bold !important;
      }
    }

  .el-menu--horizontal>.el-menu-item {
      color: #333;
      &.is-active {
        color: #409EFF;
        background: none;
      }
    }

    .el-table {
      width: 870px;
      .position-table {
          .el-button--text {
            font-size: 14px;
            color: #303133;
              
            &:hover {
              color: #409EFF;
            }
          }
      }
    }

    .null {
        text-align: center;
        .el-button {
            padding: 0;
            margin-top: 12px;
            width: 160px;
            min-height: 30px;
            line-height: 30px;
            height: 30px;
            color: #409EFF;
            border-color: #409EFF;
        }
    }
    
    .main {
      position: relative;
      padding: 10px 0 20px;
      background: none;

      .content {
        display: block;
        margin: auto;
        width: 926px;
      }
    }
    .catolog-head {
      overflow: hidden;
    }
  
    .class-schedule-card-main {
      clear: both;
      margin: auto;
     
      padding: 24px 30px;
      width: 926px;
      box-sizing: border-box;
      background: #fff;
      &~.class-schedule-card-main{
        margin-top: 30px;
      }
      .float-right {
        padding-right: 60px;
      }
      .position {
            span {
                font-size: 14px;
                color: #999999;
                cursor: pointer;
                &.active,
                &:hover { 
                    color: #409EFF;
                }
                &.padding {
                    padding: 0 8px;
                    color: #e5e5e5;
                }
            }
        }
        h2 {
          font-size: 14px;
          font-weight: bold;
        } 

      .class-schedule-card-head {
        overflow: hidden;
        
        
      
      }
    
           
    }
    .overflow {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
    }
     .cata_box{
       margin-top: 24px;
       width: 869px;
          .cata_item_box {
              margin-bottom: 20px;
              .cata_title_text {
                padding: 0 12px;
                  font-size:14px;
                  line-height:40px;
                  color:rgba(51,51,51,1);
                  background: #F8F8F8;
                  // margin-bottom: 20px;
                  display: flex;
                  justify-content: space-between;
                  &>span:nth-of-type(1){
                      font-weight:bold;
                  }
                  &>span:nth-of-type(2){
                      color: #999;
                      margin-left: 29px;
                  }
              }
              .no_task_box {
                  height: 40px;
                  line-height: 40px;
                  color: #999;
                  padding: 0 20px;
              }
              .section_box {
                  padding: 0 12px;
                  height: 40px;
                  margin-bottom: 6px;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  // background:rgba(248,248,248,1);
                  &>div:nth-of-type(1){
                      display: flex;
                      &>p:nth-of-type(1){
                          width: 53px;                                                
                          color: #999;
                      }
                      &>p:nth-of-type(2){
                          width: 660px;
                          white-space: nowrap;
                          text-overflow: ellipsis;
                          overflow: hidden;
                          word-break: break-all;
                      }
                  }
                  &>div:nth-of-type(2){
                      .no_hover_box {
                          display: flex;
                          &>img {
                              width: 14px;
                              height: 14px;
                              margin-right: 10px
                          }
                          &>p{
                              width: 32px;
                              color: #999;
                          }
                      }
                      .hover_box {
                          display: none;
                          color: #409EFF;
                          &>div {
                              display: flex;
                              &>img {
                                  width: 14px;
                                  height: 14px;
                                  margin-right: 6px
                              }
                          }
                      }
                  }
              }
              .section_box:nth-last-of-type(1) {
                  margin-bottom:0;
              }
              .section_box:hover{
                  cursor: pointer;
                  background:rgba(241,248,255,1);
                  &>div:nth-of-type(2){
                      .no_hover_box {
                          display: none;
                      }
                      .hover_box {
                          display: flex;
                      }
                  }
              }
              
              .section_box_ques {
                  padding: 0 12px;
                  height: 40px;
                  margin-bottom: 6px;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  background: rgba(248, 248, 248, 1);
                  & > div:nth-of-type(1) {
                      display: flex;
                      & > p:nth-of-type(1) {
                          width: 0px;
                          color: #999;
                      }
                      & > p:nth-of-type(2) {
                          width: 660px;
                          white-space: nowrap;
                          text-overflow: ellipsis;
                          overflow: hidden;
                          word-break: break-all;
                      }
                  }
                  & > div:nth-of-type(2) {
                      .no_hover_box {
                          display: flex;
                          & > img {
                              width: 14px;
                              height: 14px;
                              margin-right: 10px
                          }
                          & > p {
                              width: 32px;
                              color: #999;
                          }
                      }
                      .hover_box {
                          display: none;
                          color: #409EFF;
                          & > div {
                              display: flex;
                              & > img {
                                  width: 14px;
                                  height: 14px;
                                  margin-right: 6px
                              }
                          }
                      }
                  }
              }
              .section_box_ques:nth-last-of-type(1) {
                  margin-bottom: 0;
              }
              .section_box_ques:hover{
                  cursor: pointer;
                  background:rgba(241,248,255,1);
                  &>div:nth-of-type(2){
                      .no_hover_box {
                          display: none;
                      }
                      .hover_box {
                          display: flex;
                      }
                  }
              }
          }
          .cata_item_box:nth-last-of-type(1) {
              margin-bottom:0;
          }
      }    
    .icon-left,
    .icon-right {
      position: absolute;
      top: 81px;
      img {
        width: 8px;
        height: 16px;
        cursor: pointer;
      }
    }
    .icon-left {
      left: 0
    }
    .icon-right {
      right: 0;
    }

    .head-card {
      position: relative;
      float: left;
      margin-right: 10px;
      padding: 12px;
      width:224px;
      height:140px;
      box-sizing: border-box;
      border: solid 1px rgba(0,0,0,0);
      background: #F2F2F2;
      cursor: pointer;
      // transition: all .5s;
      // -o-transition: all .5s;
      // -ms-transition: all .5s;
      // -webkit-transition: all .5s;
      // -moz-transition: all .5s;

      .zd,
      &:hover {
        transition: all .5s;
        -o-transition: all .5s;
        -ms-transition: all .5s;
        -webkit-transition: all .5s;
        -moz-transition: all .5s;
      }
      .zd {
        opacity: 0;
      }
      &:hover {
        border: solid 1px #409EFF;
        .zd {
          opacity: 1;
        }
      }
      .pay-tag {
        position: absolute;
        top: -1px;
        right: -1px;
        width:48px;
        height:20px;
        background:rgba(255,109,109,1);
        border-radius:0px 0px 0px 4px;
        line-height: 20px;
        text-align: center;
        color: #fff;
        font-size: 12px;
      }


      &:last-child {
        margin-right: 0
      }

      .el-button {
        padding: 0 8px;
        height:20px;
        min-height: 20px;
        line-height: 20px;
        font-size: 12px;
        border: solid 1px #A4D1FF;
        color: #A4D1FF;
        background: #f2f2f2;
        border-radius: 2px;

      }
      .text-overflow {
        margin-top: 12px;
        font-size: 14px;
        color: #666;
      }
      .progress {
        margin-top: 16px;
        height: 4px;
      }

      .el-progress {
        .el-progress-bar__inner {
          background-color: #8CC4FF;
        }
        .el-progress-bar__outer {
          height: 4px !important;
          background: #E5E5E5;
        }
      }
      .progress-txt_box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .right {
          margin-top: 8px;
          color: #EC5E69;
          font-size: 12px;
        }
      }
      .progress-txt {
        margin-top: 8px;
        font-size: 12px;
        color: #999;
      }

      &.active {
        background: #409EFF;
        .el-button {
          border-color: #fff;
          background: #409EFF;
          color: #fff;
        }
        .text-overflow,
        .progress-txt {
          color: #fff;
        }
        .progress-txt_box {
          .right {
            color: #F8FF6F;
          }
        }

        .el-progress {
          .el-progress-bar__inner {
            background-color: #fff;
          }
          .el-progress-bar__outer {
            background: #A4D1FF;
          }
        }
        &:after {
          content: "";
          position: absolute;
          bottom: -29px;
          width: 0;
          margin: auto;
          left: 0;
          right: 0;
          height: 0;
          border: 19px solid transparent;
          border-top-color: #409EFF;
        }

      }
    }
}
</style>